// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HostDetail-showHideBtn-MkKe2,
.HostDetail-showHideBtn-MkKe2.HostDetail-focus-Ypu3d,
.HostDetail-showHideBtn-MkKe2:active,
.HostDetail-showHideBtn-MkKe2:hover {
  padding: 0px !important;
  font-weight: 500;
  word-wrap: break-word;
  line-height: 18px;
  letter-spacing: normal;
  font-size: 18px;
  border: 0px !important;
  text-decoration: none !important;
  border-bottom: 1px solid var(--common-link-color) !important;
  color: var(--common-link-color) !important;
}

.HostDetail-displayFlex-z1uUs {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}`, "",{"version":3,"sources":["webpack://./src/components/ViewListing/HostDetail/HostDetail.css"],"names":[],"mappings":"AAAA;;;;EAIE,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,gCAAgC;EAChC,4DAA4D;EAC5D,0CAA0C;AAC5C;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB","sourcesContent":[".showHideBtn,\n.showHideBtn.focus,\n.showHideBtn:active,\n.showHideBtn:hover {\n  padding: 0px !important;\n  font-weight: 500;\n  word-wrap: break-word;\n  line-height: 18px;\n  letter-spacing: normal;\n  font-size: 18px;\n  border: 0px !important;\n  text-decoration: none !important;\n  border-bottom: 1px solid var(--common-link-color) !important;\n  color: var(--common-link-color) !important;\n}\n\n.displayFlex {\n  display: flex;\n  align-items: flex-start;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"showHideBtn": `HostDetail-showHideBtn-MkKe2`,
	"focus": `HostDetail-focus-Ypu3d`,
	"displayFlex": `HostDetail-displayFlex-z1uUs`
};
module.exports = ___CSS_LOADER_EXPORT___;
